/**
 * API functions for SyntheticExcessSpread entity.
 */
import { ApiEndPoints, HttpMethods } from "../base/Settings";
import type {
    FetchRequest,
    SyntheticExcessSpread,
    SyntheticExcessSpreadInput,
    UUID,
    WaterfallItemInput
} from "../base/ui_general/GeneralInterfaces";

/**
 * Creates a FetchRequest object for creating a new synthetic excess spread, including both the synthetic excess spread and its associated waterfall item.
 * @param syntheticExcessSpreadInput An object of type SyntheticExcessSpreadInput containing the input data for creating the synthetic excess spread.
 * @param waterfallItemInput An object of type WaterfallItemInput containing the input data for the associated waterfall item.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_create_synthetic_excess_spread(syntheticExcessSpreadInput: SyntheticExcessSpreadInput, waterfallItemInput: WaterfallItemInput): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.SYNTHETIC_EXCESS_SPREAD,
        method: HttpMethods.POST,
        query_parameters: {},
        body: {
            waterfall_item: waterfallItemInput,
            synthetic_excess_spread: syntheticExcessSpreadInput
        },
    }
}

export function getRequest_update_synthetic_excess_spread(syntheticExcessSpread: SyntheticExcessSpread): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.SYNTHETIC_EXCESS_SPREAD,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: syntheticExcessSpread,
    };
}

export function getRequest_get_all_synthetic_excess_spreads(transaction_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.SYNTHETIC_EXCESS_SPREAD,
        method: HttpMethods.GET,
        query_parameters: { transaction_id },
    };
}
